module.exports = __webpack_public_path__ + "static/media/fowdarkening.f2b23103.frag";